import { IChildrenProps } from '@/typings/children-props'

export const RestaurantFlashDealPreview = ({ children }: IChildrenProps) => {
    return (
        <div
            className="bg-neotaste-dark text-neotaste rounded-full w-fit flex items-center justify-center px-3 font-semibold text-[12px] py-2
                gap-x-1 whitespace-nowrap min-h-8 max-h-8"
        >
            <img
                src="/_images/big-icons/bolt.svg"
                alt="Bolt icon"
                className="h-[1em] w-[1em]"
                aria-hidden
            />
            <span className="mt-[1px] leading-none">{children}</span>
        </div>
    )
}
